import axios from "axios";
import firebase from '../../src/config/firebase';
import driverService from "./driver.service";
require('firebase/auth')

const notification = {
    
    async sendNotification(userIdNotification, message, title = null, freightData = null) {
  
      console.log("Enviando notificação para o motorista : " + userIdNotification)
      console.log(message)

      // Formatar notificação no estilo iFood
      const notificationPayload = this.formatNotificationPayload(
        userIdNotification, 
        message, 
        title, 
        freightData
      );

      axios.post(
        "https://m80mhwbs12.execute-api.us-east-1.amazonaws.com/production/notificationapp",
        notificationPayload
      )
      .then((response) => console.log(response.data))
      .catch((err) => {
        console.error("ops! não conseguimos comunicação com o push notification: " + err);
      });

    }, 

    async sendNotificationToAll(numerFreight, groupId, dateColeta, origem = null, destino = null) {
      console.log("Enviando notificação para todos os motoristas do grupo : " + groupId)
      //Listar todos os motoristas que são do grupo 
      const drivers = await firebase.firestore()
        .collection('drivers_users')
        // .where('groupId', '==', groupId)
        .get();
      // Formatar datas uma vez antes do loop
      const dateColetaFormatted = this.formatDateToBrazilian(dateColeta);
      
      const currentDateTimeFormatted = this.formatDateTimeToBrazilian(new Date());


      console.log("Enviar mensagem para " + drivers.docs.length + " motoristas")

      drivers.docs.forEach(driver => {

      // Criar título e mensagem estilizados no estilo iFood
      var title = `🚚 Nova Oportunidade de Frete!`;
      var message = `Olá ${driver.data().name}! 📦\n\n` +
        `Frete #${numerFreight} disponível\n` +
        `📅 Coleta: ${dateColetaFormatted}\n\n` +
        (origem ? `📍 Origem: ${origem}\n` : '') +
        (destino ? `🎯 Destino: ${destino}\n\n` : '\n') +
        `⚡ Corre que está dando sopa! Entre na fila agora e garanta esse frete.\n\n` +
        `🕐 ${currentDateTimeFormatted}`;

      // Dados adicionais do frete para notificação rica
      const freightData = {
        freightNumber: numerFreight,
        collectionDate: dateColetaFormatted,
        origin: origem,
        destination: destino,
        timestamp: currentDateTimeFormatted
      };

      console.log("Enviando notificação para o motorista : " + driver.data().idNotification)
      console.log(numerFreight)

      // Formatar notificação no estilo iFood
      const notificationPayload = this.formatNotificationPayload(
        driver.data().idNotification,
        message,
        title,
        freightData
      );
  
        axios.post(
          "https://m80mhwbs12.execute-api.us-east-1.amazonaws.com/production/notificationapp",
          notificationPayload
        )
        .then(response => {
          console.log("mensagem enviada com sucesso");
          console.log(response.data);

          driverService.saveMessageInMyFreight(
            driver.data().uid, 
             title, 
             message
          );

          console.log(response.data);
        })
        .catch((err) => {
          console.error("ops! não conseguimos comunicação com o push notification: " + err);
        });

      });

    }, 

    formatDateToBrazilian(date) {
      if (!date) return "";
      
      try {
        let dateObj;
        
        // Se for string no formato YYYY-MM-DD
        if (typeof date === 'string' && date.includes('-')) {
          const [year, month, day] = date.split('-');
          return `${day}/${month}/${year}`;
        }
        
        // Se for um objeto Date
        if (date instanceof Date) {
          dateObj = date;
        } else if (typeof date === 'string') {
          dateObj = new Date(date);
        } else if (date && date.seconds) {
          // Se for um timestamp do Firebase
          dateObj = new Date(date.seconds * 1000);
        } else {
          dateObj = new Date(date);
        }
        
        if (isNaN(dateObj.getTime())) {
          return "";
        }
        
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        
        return `${day}/${month}/${year}`;
      } catch (error) {
        console.error("Erro ao formatar data:", error);
        return "";
      }
    },

    // Função para formatar data e hora para o formato brasileiro
    formatDateTimeToBrazilian(date) {
      if (!date) {
        date = new Date();
      }
      
      try {
        const dateObj = date instanceof Date ? date : new Date(date);
        
        if (isNaN(dateObj.getTime())) {
          return "";
        }
        
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getSeconds()).padStart(2, '0');
        
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        console.error("Erro ao formatar data/hora:", error);
        return "";
      }
    },

    // Função para formatar payload de notificação no estilo iFood
    formatNotificationPayload(userId, message, title = null, freightData = null) {
      // Se title não foi fornecido, extrair do início da mensagem ou usar padrão
      if (!title) {
        // Tentar extrair título da mensagem (primeira linha antes de \n)
        const lines = message.split('\n');
        title = lines[0] || "🚚 Fortio - Nova Notificação";
      }

      // Criar mensagem formatada no estilo iFood
      // Combinar título e mensagem de forma elegante
      let formattedMessage = title + '\n\n' + message;

      // Payload base - mantém compatibilidade com API atual
      // A API pode processar campos adicionais se suportar notificações ricas
      const payload = {
        userId: userId,
        message: formattedMessage, // Mensagem completa para compatibilidade
        // Campos adicionais para notificações ricas (estilo iFood)
        // Se a API suportar, esses campos serão usados; caso contrário, apenas message será usado
        title: title,
        body: message,
        // Dados adicionais estruturados para o app mobile processar
        data: {
          type: 'freight_notification',
          ...(freightData || {}),
          timestamp: new Date().toISOString()
        },
        // Configurações de notificação no estilo iFood
        priority: 'high',
        sound: 'default',
        badge: 1,
        // Ícone e imagem (se suportado pelo app)
        icon: 'ic_notification',
        // Ações rápidas (se suportado pelo app mobile)
        actions: [
          {
            action: 'view',
            title: '👁️ Ver Frete'
          },
          {
            action: 'dismiss',
            title: '❌ Fechar'
          }
        ]
      };

      return payload;
    },

} 

export default notification;

